import api from '../../../seller-apis/api';
import { pdetailData, transferPriceHistory } from '../../../seller-apis/apidataField';
import servicesApi from '../../../seller-apis/servicesApi';


export const fetchProductDetailSingle = async (dispatch, data) => {
    console.log(data)
    try {
        dispatch({
            type: "FETCH_PRO_DETAIL_SINGLE"
        })
        const res = await api.product.productsRetrieveall(pdetailData(data));
        console.log(res)
        let catList = [];
        let catname;
        const ress =  await servicesApi.categories.categoryTree({})
        catList = ress.data.subCategories;
        res.products[0].categories.map((item, index) => {
            catList.map((pitem, pindex) => {
              if (item === pitem._id) {
                catname = pitem.categoryName
              }
            })
          })
        dispatch({
            type: "FETCH_PRO_DETAIL_SINGLE_SUCCESS",
            payload: { "data": res.products[0],"category":catname }
        })
        if (res.products[0].vendors[0].prSts) {
            let dat = {
                "pageNo": 1,
                "selectedId": data.pId,
            }
            fetchTransferPriceHistory(dispatch, dat)
        }
    }
    catch (error) {
        dispatch({
            type: "FETCH_PRO_DETAIL_SINGLE_ERROR",
            payload: error
        })
    }
}

export const fetchTransferPriceHistory = async (dispatch, data) => {
    try {
        dispatch({
            type: "FETCH_PRICE_HISTORY_SINGLE"
        })
        const res = await api.product.vPriceReqRetrieveAll(transferPriceHistory(data));
        dispatch({
            type: "FETCH_PRICE_HISTORY_SINGLE_SUCCESS",
            payload: res
        })
    }
    catch (error) {
        dispatch({
            type: "FETCH_PRICE_HISTORY_SINGLE_ERROR",
            payload: error
        })
    }
}

export const updateProductStatusSingle = async (dispatch, data) => {
    try {
        dispatch({
            type: "UPDATE_STATUS_PRODUCT_SINGLE"
        })
        const res = await api.product.addToExProduct(data);
        dispatch({
            type: "UPDATE_STATUS_PRODUCT_SINGLE_SUCCESS",
            payload: { "res": res, "data": data }
        })

        let data1 = {
            pId: data._id,
        };
        fetchProductDetailSingle(dispatch, data1);
    }
    catch (error) {
        console.log(error)
        dispatch({
            type: "UPDATE_STATUS_PRODUCT_SINGLE_ERROR",
            payload: error
        })
    }
}

export const updateProductGSTSingle = async (dispatch, data) => {
    try {
        dispatch({
            type: "UPDATE_GST_PRODUCT_SINGLE"
        })
        const res = await api.product.addToExProduct(data);
        dispatch({
            type: "UPDATE_GST_PRODUCT_SINGLE_SUCCESS",
            payload: { "data": res, "gst": data.taxClass }
        })
    }
    catch (error) {
        dispatch({
            type: "UPDATE_GST_PRODUCT_SINGLE_ERROR",
            payload: error
        })
    }
}


export const updateOfferPriceReqSingle = async (dispatch, data) => {
    try {
        dispatch({
            type: "UPDATE_OFFER_PRICEREQ_PRODUCT_SINGLE"
        })
        const res = await api.transferprice.updatePriceRequest(data);
        dispatch({
            type: "UPDATE_OFFER_PRICEREQ_PRODUCT_SINGLE_SUCCESS",
            payload: {"res":res,"data":data.price}
        })
        let vdata = {
            "pageNo":1,
            "selectedId":data.product
        }
        fetchTransferPriceHistory(dispatch, vdata)
        console.log(data)
    }
    catch (error) {
        dispatch({
            type: "UPDATE_OFFER_PRICEREQ_PRODUCT_SINGLE_ERROR",
            payload: error
        })
    }
}

export const verifyTransferPriceSingle = async (dispatch, data) => {
    try {
        dispatch({
            type: "VERIFY_PRICE_PRODUCT_SINGLE"
        })
        if (data.spcl === "addToEx") {
            const res = api.product.addToExProduct(data.data);
            dispatch({
                type: "VERIFY_PRICE_PRODUCT_SINGLE_SUCCESS",
                payload: res
            })
        }
        else {
            const res = api.transferprice.updatePriceRequest(data.data);
            dispatch({
                type: "VERIFY_PRICE_PRODUCT_SINGLE_SUCCESS",
                payload: res
            })
        }
    }
    catch (error) {
        dispatch({
            type: "VERIFY_PRICE_PRODUCT_SINGLE_ERROR",
            payload: error
        })
    }
}

export const newPriceReqSingle = async (dispatch, data) => {
    try {
        dispatch({
            type: "NEW_PRICEREQ_SINGLE"
        })
        const res = await api.transferprice.priceChangeRquest(data);
        dispatch({
            type: "NEW_PRICEREQ_SINGLE_SUCCESS",
            payload: {"res":res,"data":data}
        })
        let vdata = {
            "pageNo":1,
            "selectedId":data.product
        }
       fetchTransferPriceHistory(dispatch, vdata)
       // fetch product details
       let data1 = {
        pId: data.product,
       };
       fetchProductDetailSingle(dispatch, data1);
    }
    catch (error) {
        dispatch({
            type: "NEW_PRICEREQ_SINGLE_ERROR",
            payload: error
        })
    }   
}
